import { MATCH_MODES, type MatchModeId } from "@golazo/shared";

/**
 * Cuantos juegan en ESTE ordenador (Local / IA).
 *
 * El menu prometia "Vs. IA o 2 Jugadores" desde el primer dia y el modo de dos
 * no existia: un jugador lo reclamo en Discord (2026-09-28). `together` = los
 * dos en el mismo equipo contra la IA; `versus` = uno contra otro, cada uno con
 * su equipo de IA.
 */
export type LocalPlayers = "solo" | "together" | "versus";

export const LOCAL_PLAYERS: readonly LocalPlayers[] = ["solo", "together", "versus"];

/** El jugador 1 va siempre de local, en el asiento que el modo da al humano. */
export function firstSeat(modeId: MatchModeId): string {
  return `home-${MATCH_MODES[modeId].controlledIndex}`;
}

/**
 * El asiento del jugador 2, o `null` si con esa eleccion no cabe en el modo.
 *
 * Juntos: el primer companero de CAMPO (el portero siempre es de la IA), asi
 * que en 2v2 —portero y uno— no hay sitio. Cara a cara: el mismo puesto en el
 * otro equipo, para que el duelo sea parejo.
 */
export function secondSeat(modeId: MatchModeId, players: LocalPlayers): string | null {
  if (players === "solo") return null;
  const mode = MATCH_MODES[modeId];
  if (players === "versus") return `away-${mode.controlledIndex}`;
  const mate = mode.formation.findIndex((spec, i) => i !== mode.controlledIndex && spec.role !== "gk");
  return mate >= 0 ? `home-${mate}` : null;
}
